import { map } from "../../utils/lodash";
import { OperatorType } from "../enums/OperatorType";
import { VariableModel } from "../VariableModel";
import { createLogic } from "./logicFactory";
import { getSettingString } from "../utilities/settingUtilities";

export function createLookupTableFilter(filter: any, variables: VariableModel[]) {
    if (filter == null || filter.conditions == null) {
        return undefined;
    }
    let expression: string = removeUnsupportedOperators(filter.syntax);
    for (let i = filter.conditions.length; i >= 1; i--) {
        const condition = parseCondition(filter.conditions[i - 1], variables);
        // If it has a custom condition grouping then use provided syntax.
        if (filter.syntax) {
            // Insert the condition in its correct index in the expression.
            expression = expression.replace(i.toString(), formatCondition(condition));
        } else {
            if (expression !== "") expression += ` ${filter.operator} `;
            expression += formatCondition(condition);
        }
    }
    return createLogic(`logic:basic;${expression}`);
}

function parseCondition(condition: any, variables: VariableModel[]) {
    // For IN and NOT IN operators
    let isList = false;
    switch (OperatorType[condition.operator as string]) {
        case OperatorType.Contains:
            condition.operator = "LIKE";
            condition.value = `%${condition.value}%`;
            break;
        case OperatorType.Equals:
            condition.operator = "=";
            break;
        case OperatorType.DifferentThan:
            condition.operator = "!=";
            break;
        case OperatorType.LessThan:
            condition.operator = "<";
            break;
        case OperatorType.MoreThan:
            condition.operator = ">";
            break;
        case OperatorType.LessThanOrEqual:
            condition.operator = "<=";
            break;
        case OperatorType.MoreThanOrEqual:
            condition.operator = ">=";
            break;
        case OperatorType.DoesNotContain:
            condition.operator = "NOT LIKE";
            condition.value = `%${condition.value}%`;
            break;
        case OperatorType.Empty:
            condition.operator = "=";
            condition.value = "";
            break;
        case OperatorType.NotEmpty:
            condition.operator = "!=";
            condition.value = "";
            break;
        case OperatorType.In:
            condition.value = formatValueList(condition.value);
            isList = true;
            break;
        case OperatorType.NotIn:
            condition.operator = "NOT IN";
            condition.value = formatValueList(condition.value);
            isList = true;
            break;
    }
    if (!isList && !condition.value.match("^[0-9]+$")) {
        condition.value = `'${condition.value}'`;
    }
    condition.variableName = getColumnName(condition.variableName, variables);
    return condition;
}

function removeUnsupportedOperators(syntax: string) {
    if (syntax) return syntax.toUpperCase().replace(/[^(\(|\)|OR|AND|\s|\d)]/g, "");
    return "";
}

function formatCondition(condition: any) {
    return `${condition.variableName} ${condition.operator} ${condition.value}`;
}

function getColumnName(variableName: string, variables: VariableModel[]): string {
    const variable = variables.find((v) => v.name === variableName);
    if (variable) return getSettingString(variable, "ColumnName", variableName);
    return variableName;
}

function formatValueList(value: string) {
    return `(${map(value.split(","), (v) => `'${v.trim()}'`).join(",")})`;
}
